import { render, staticRenderFns } from "./LayoutTags.vue?vue&type=template&id=131ba9aa&"
import script from "./LayoutTags.vue?vue&type=script&lang=js&"
export * from "./LayoutTags.vue?vue&type=script&lang=js&"
import style0 from "./LayoutTags.vue?vue&type=style&index=0&id=131ba9aa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports